// SQL コマンド（キーワード）学習用データ
// 形は yoji... のエントリと互換（text, color は必須。mondai/usage/example 等は UI が参照するため極力用意）
// App 側では未読込のため、差し替え時は `import { sqlCommands } from "./data/sql_commands"` などで利用してください。

export const sqlCommands = [
  {
    text: "SELECT",
    color: "#4CAF50",
    kunyomi: "選び抜け。必要な列だけを引き当てろ。",
    mondai: "特定の列だけを取得したい。",
    example: [
      "SELECT id, name FROM users;"
    ],
    origin: "レコード集合から列を選択して取り出す基本操作。",
    usage: "必要な列だけを取得したいときに使う。WHERE などと組み合わせて無駄を削ると効率的。",
    background: "SQL の中心的動詞でデータ取得の起点。"
  },
  {
    text: "INSERT",
    color: "#2196F3",
    kunyomi: "新たな行を刻め。",
    mondai: "新しい行を追加したい。",
    example: [
      "INSERT INTO users (name, email) VALUES ('Taro', 'taro@example.com');"
    ],
    origin: "表に新しい行を挿入する。",
    usage: "新しいデータを追加したいときに使う。\n列指定を明示し、想定外の列順変化に備えるのが安全。"
  },
  {
    text: "UPDATE",
    color: "#FF9800",
    kunyomi: "記録を上書きし、真を保て。",
    mondai: "データを更新したい。",
    example: [
      "UPDATE users SET email = 'new@example.com' WHERE id = 10;"
    ],
    origin: "既存行を更新する。",
    usage: "既存のデータを変更したいときに使う。WHERE を忘れると全件更新の事故に。必ず条件を確認。"
  },
  {
    text: "DELETE",
    color: "#F44336",
    kunyomi: "不必要を断て。",
    mondai: "レコードを削除したい。",
    example: [
      "DELETE FROM users WHERE id = 10;"
    ],
    origin: "既存行を削除する。",
    usage: "不要なデータを削除したいときに使う。\nUPDATE 同様に WHERE が命。\n論理削除の方針も要検討。"
  },
  {
    text: "WHERE",
    color: "#9C27B0",
    kunyomi: "条件を定め、的を射よ。",
    mondai: "条件に合うデータだけに絞り込みたい。",
    example: [
      "SELECT * FROM users WHERE age >= 20;"
    ],
    origin: "行を条件で絞り込み。",
    usage: "条件に合うデータだけを抽出したいときに使う。\nAND/ORや括弧で優先順位に注意。\n例：年齢が20歳以上のユーザーだけを取得したいとき。"
  },
  {
    text: "ORDER BY",
    color: "#795548",
    kunyomi: "秩序を与えよ。",
    mondai: "データを昇順や降順で並べたい。",
    example: [
      "SELECT * FROM posts ORDER BY created_at DESC;"
    ],
    origin: "結果セットの並び替え。",
    usage: "複数キーや昇降の混在指定も可能。"
  },
  {
    text: "GROUP BY",
    color: "#3F51B5",
    kunyomi: "群を作り、要約せよ。",
    mondai: "グループごとに集計したい。",
    example: [
      "SELECT user_id, COUNT(*) AS cnt FROM posts GROUP BY user_id;"
    ],
    origin: "同値の行をグルーピング。",
      usage: "属性ごとに集計や傾向を知りたいときに使う。\nSELECT句にはGROUP BYで指定した列か集約関数の列だけを入れるのがコツ。\n例：ユーザーごとに投稿数を集計したいとき。"
  },
  {
    text: "HAVING",
    color: "#607D8B",
    kunyomi: "群の後にふるいをかけろ。",
    mondai: "集計結果に条件をつけたい。",
    example: [
      "SELECT user_id, COUNT(*) AS cnt FROM posts GROUP BY user_id HAVING COUNT(*) >= 10;"
    ],
    origin: "集約後の行に条件を課す。",
    usage: "集計前の絞り込みはWHERE、集計後の絞り込みはHAVING。"
  },
  {
    text: "JOIN",
    color: "#009688",
    kunyomi: "関係を結べ。",
    mondai: "両方の表で条件が合うデータだけを結合したい。",
    example: [
      "SELECT u.name, p.title FROM users u JOIN posts p ON p.user_id = u.id;"
    ],
    origin: "複数テーブルの行を結合。",
    usage: "2つの表で共通するデータだけを結合したいときに使う。\nON句で結合条件を明示し、テーブルに別名をつけると可読性が上がる。\n例：ユーザーと投稿をuser_idで結合し、両方の情報を一覧したいとき。"
  },
  {
    text: "LEFT JOIN",
    color: "#8BC34A",
    kunyomi: "左の欠けを許す寛容。",
    mondai: "どちらか一方にしかないデータもまとめて一覧したい。",
    example: [
      "SELECT u.name, p.title FROM users u LEFT JOIN posts p ON p.user_id = u.id;"
    ],
    origin: "左表の全行を保ち、右表が無ければ NULL。",
    usage: "片方の表にしかないデータも含めて一覧したいときに使う。\n関連が存在しない場合はNULLになるので注意。\n例：投稿がないユーザーも含めてユーザー一覧を作りたいとき。"
  },
  {
    text: "RIGHT JOIN",
    color: "#CDDC39",
    kunyomi: "右の面目も立てよ。",
    mondai: "右側のデータを全て残して結合したい。",
    example: [
      "SELECT orders.id, products.name FROM products RIGHT JOIN orders ON products.id = orders.product_id;"
    ],
    origin: "右表を優先して結合。",
    usage: "右側のデータをすべて残して結合したいときに使う。\n例：すべての注文を一覧し、商品があれば商品名も一緒に見たいとき。"
  },
  {
    text: "UNION",
    color: "#FFEB3B",
    kunyomi: "集合を束ねよ。",
    mondai: "2つの結果をまとめて一覧にしたい。",
    example: [
      "SELECT id FROM a UNION SELECT id FROM b;"
    ],
    origin: "結果セットの和（重複除外）。",
    usage: "複数のSELECT結果をまとめたいときに使う。\n重複を残したいなら UNION ALL。\n例：会員テーブルとゲストテーブルのメールアドレスを1つのリストにしたいとき。"
  },
  {
    text: "DISTINCT",
    color: "#FFC107",
    kunyomi: "唯一を数えろ。",
    mondai: "重複を除いてデータを取り出したい。",
    example: [
      "SELECT DISTINCT city FROM users;"
    ],
    origin: "重複行を取り除く。",
    usage: "重複を除いたデータだけを取得したいときに使う。\nCOUNT(DISTINCT col) でユニーク数を集計。\n例：登録ユーザーの中から、重複しない都市名リストを作りたいとき。"
  },
  {
    text: "LIMIT",
    color: "#00BCD4",
    kunyomi: "欲張るな。必要な分だけ。",
    mondai: "最初の 10 件だけ見たい。",
    example: [
      "SELECT * FROM posts ORDER BY id DESC LIMIT 10;"
    ],
    origin: "返す行数の上限。",
    usage: "表示件数を制限したいときに使う。\nOFFSETと組み合わせてページング処理も可能。\n例：最新10件だけを表示したいとき。"
  },
  {
    text: "OFFSET",
    color: "#03A9F4",
    kunyomi: "少し先から始めよ。",
    mondai: "11件目から 10 件取りたい。",
    example: [
      "SELECT * FROM posts ORDER BY id DESC LIMIT 10 OFFSET 10;"
    ],
    origin: "先頭からのスキップ数。",
    usage: "途中からデータを取りたいときに使う。\nOFFSETが大きいと遅くなるので注意。"
  },
  {
    text: "BETWEEN",
    color: "#673AB7",
    kunyomi: "範囲を定めよ。",
    mondai: "範囲を指定して絞りたい。",
    example: [
      "SELECT * FROM orders WHERE ordered_at BETWEEN '2025-01-01' AND '2025-01-31';"
    ],
    origin: "含む範囲条件。",
    usage: "範囲でデータを絞りたいときに使う。\n日時で絞る場合、端点の扱い（含む/含まない）に注意。"
  },
  {
    text: "LIKE",
    color: "#E91E63",
    kunyomi: "曖昧を拾え。",
    mondai: "部分一致/あいまい検索したい。",
    example: [
      "SELECT * FROM users WHERE name LIKE 'Ta%';"
    ],
    origin: "ワイルドカード検索（% / _）。",
    usage: "部分一致やあいまい検索をしたいときに使う。\n前方一致は索引が効きやすいが、前方%は遅くなりがち。\n例：名前に特定の文字列が含まれるユーザーを探したいとき。"
  },
  {
    text: "IN",
    color: "#9E9E9E",
    kunyomi: "集合に属するか。",
    mondai: "id が 1, 3, 5 の行を取りたい。",
    example: [
      "SELECT * FROM users WHERE id IN (1,3,5);"
    ],
    origin: "値の集合に含まれるか判定。",
    usage: "複数の値に合致するデータをまとめて取得したいときに使う。\nサブクエリ IN も可。大量要素は別テーブル化も検討。\n例：特定の会員IDリストに該当するユーザーだけ抽出したいとき。"
  },
  {
    text: "IS NULL",
    color: "#607D8B",
    kunyomi: "空白も意味を持つ。",
    mondai: "値が未設定のデータだけ取り出したい。",
    example: [
      "SELECT * FROM users WHERE email IS NULL;"
    ],
    origin: "NULL 判定。= NULL ではダメ。",
    usage: "値が未設定のデータだけを抽出したいときに使う。\nNOT NULL と対で覚える。\n例：メールアドレスが未登録のユーザーだけを抽出したいとき。"
  },
  {
    text: "CREATE TABLE",
    color: "#8E24AA",
    kunyomi: "器をこしらえよ。",
    mondai: "テーブルを新規作成したい。",
    example: [
      "CREATE TABLE users (\n  id SERIAL PRIMARY KEY,\n  name TEXT NOT NULL,\n  email TEXT UNIQUE\n);"
    ],
    origin: "新しい表を定義。",
    usage: "新しくテーブルを作成したいときに使う。\n主キーやNOT NULL、UNIQUEなどの制約は設計段階で決めておくと安全。\n例：ユーザー情報を保存するためのusersテーブルを新規作成したいとき。"
  },
  {
    text: "ALTER TABLE",
    color: "#5E35B1",
    kunyomi: "器を作り替えよ。",
    mondai: "テーブルの構造を変更したい。",
    example: [
      "ALTER TABLE users ADD COLUMN age INTEGER;"
    ],
    origin: "表定義の変更。",
    usage: "テーブルの列や制約など、構造をあとから変更したいときに使う。\nロック・ダウンタイムを考慮。DB ごとの制限も確認。\n例：新しい列を追加したり、不要な列を削除したり、列の型や制約を変更したいとき。"
  },
  {
    text: "DROP TABLE",
    color: "#C62828",
    kunyomi: "覚悟して、壊せ。",
    mondai: "不要になったテーブルを削除したい。",
    example: [
      "DROP TABLE IF EXISTS temp_work;"
    ],
    origin: "表の削除。",
    usage: "IF EXISTS で安全側。誤爆防止に環境確認を徹底。"
  },
  {
    text: "CREATE INDEX",
    color: "#2E7D32",
    kunyomi: "道を敷け。検索を速く。",
    mondai: "検索を速くしたい。",
    example: [
      "CREATE INDEX idx_users_email ON users(email);"
    ],
    origin: "索引の作成。",
    usage: "検索を高速化したいときに使う。\n例：email列での検索が遅いので、users.emailにインデックスを作成したいとき。"
  },
  {
    text: "DROP INDEX",
    color: "#AD1457",
    kunyomi: "過剰を削れ。",
    mondai: "いらないインデックスを削除したい。",
    example: [
      "DROP INDEX IF EXISTS idx_users_email;"
    ],
    origin: "索引の削除。",
    usage: "不要なインデックスを削除したいときに使う。\n例：usersテーブルのemail列に作ったが使われていないidx_users_emailインデックスを削除したいとき。"
  },
  {
    text: "BEGIN",
    color: "#00695C",
    kunyomi: "取引を始めよ。",
    mondai: "一連の処理を始めたい。",
    example: [
      "BEGIN; -- or START TRANSACTION;"
    ],
    origin: "トランザクション開始。",
    usage: "COMMIT/ROLLBACK までの一連を意識して扱う。"
  },
  {
    text: "COMMIT",
    color: "#1B5E20",
    kunyomi: "決裁だ。記録を確定せよ。",
    mondai: "一連の変更を確定したい。",
    example: [
      "COMMIT;"
    ],
    origin: "トランザクション確定。",
    usage: "トランザクションの変更を確定したいときに使う。\n変更はここで永続化。"
  },
  {
    text: "ROLLBACK",
    color: "#B71C1C",
    kunyomi: "退け、やり直せ。",
    mondai: "一連の処理をもとに戻したい。",
    example: [
      "ROLLBACK;"
    ],
    origin: "トランザクション取消。",
    usage: "トランザクションをもとに戻したいときに使う。\nSAVEPOINT と併用で部分巻き戻しも可能。"
  },
  {
    text: "COUNT",
    color: "#455A64",
    kunyomi: "数を数えよ。",
    mondai: "総数を知りたい。",
    example: [
      "SELECT COUNT(*) FROM users;"
    ],
    origin: "集約関数（件数）。",
    usage: "データの件数や特定条件の数を知りたいときに使う。\nNULLの扱いに注意し、DISTINCTと組み合わせてユニーク数も集計できる。\n例：登録ユーザーの総数や、特定条件に合致する行数を調べたいとき。"
  },
  {
    text: "SUM",
    color: "#FF7043",
    kunyomi: "総計を示せ。",
    mondai: "合計を出したい。",
    example: [
      "SELECT SUM(amount) FROM orders;"
    ],
    origin: "集約関数（合計）。",
    usage: "合計値を出したいときに使う。SUM(amount) で売上合計など。"
  },
  {
    text: "AVG",
    color: "#26C6DA",
    kunyomi: "平均を求めよ。",
    mondai: "平均を出したい。",
    example: [
      "SELECT AVG(age) FROM users;"
    ],
    origin: "集約関数（平均）。",
    usage: "平均値を出したいときに使う。AVG(age) で平均年齢など。",
  },
  {
    text: "MIN",
    color: "#7CB342",
    kunyomi: "最小を見つけよ。",
    mondai: "一番小さい値を知りたい。",
    example: [
      "SELECT MIN(ordered_at) FROM orders;"
    ],
    origin: "集約関数（最小）。",
    usage: "最小値を知りたいときに使う。MIN(ordered_at) で最古の日付など。",
  },
  {
    text: "MAX",
    color: "#FFB300",
    kunyomi: "最大を見極めよ。",
    mondai: "一番大きい値を知りたい。",
    example: [
      "SELECT MAX(amount) FROM orders;"
    ],
    origin: "集約関数（最大）。",
    usage: "最大値を知りたいときに使う。MAX(amount) で最高金額など。"
  },
  {
    text: "CASE",
    color: "#8D6E63",
    kunyomi: "条件に応じて姿を変えよ。",
    mondai: "条件によって表示内容を変えたい。",
    example: [
      "SELECT\n  CASE\n    WHEN score >= 80 THEN 'A'\n    WHEN score >= 60 THEN 'B'\n    ELSE 'C'\n  END AS grade\nFROM exams;"
    ],
    origin: "式を条件で分岐。",
    usage: "条件によって表示内容や分類を変えたいときに使う。\n数値をランクに変換したり、値ごとに異なる文字列を表示したい場合に便利。\n例：点数に応じてA/B/C評価を付けたいとき。"
  },
  {
    text: "EXISTS",
    color: "#5D4037",
    kunyomi: "存在を問え。",
    mondai: "関連データがあるか調べたい。",
    example: [
      "SELECT * FROM users u WHERE EXISTS (SELECT 1 FROM posts p WHERE p.user_id = u.id);"
    ],
    origin: "サブクエリの存在判定。",
    usage: "関連データの有無を調べたいときに使う。\nINと比較して最適化差が出ることもある。\n例：ユーザーごとに投稿が存在するかどうかを判定したいとき。"
  },
  {
    text: "WITH",
    color: "#00BCD4",
    kunyomi: "名を与え、再利用せよ。",
    mondai: "サブクエリに名前を付け再利用したい。",
    example: [
      "WITH recent_posts AS (\n  SELECT * FROM posts WHERE created_at >= CURRENT_DATE - INTERVAL '7 days'\n)\nSELECT user_id, COUNT(*) FROM recent_posts GROUP BY user_id;"
    ],
    origin: "共通テーブル式（CTE: Common Table Expression）。",
    usage: "複雑なクエリを分割して読みやすくしたいときや、同じサブクエリを再利用したいときに使う。\n再帰CTE（WITH RECURSIVE）で階層データを扱えるDBもある。"
  },
  {
    text: "EXPLAIN",
    color: "#8BC34A",
    kunyomi: "道筋を見よ。遅さの理由を暴け。",
    mondai: "クエリが遅いので、実行計画を確認したい。",
    example: [
      "EXPLAIN SELECT * FROM users WHERE email = 'taro@example.com';"
    ],
    origin: "実行計画（クエリプラン）の表示。",
    usage: "クエリがインデックスを使っているか、どこがボトルネックかを調べたいときに使う。\nDBによっては EXPLAIN ANALYZE で実測も取れる。"
  },
  {
    text: "COALESCE",
    color: "#FFC107",
    kunyomi: "空を埋めよ。値を選び取れ。",
    mondai: "NULL のときだけ別の値を使いたい。",
    example: [
      "SELECT COALESCE(display_name, name, 'unknown') AS name_for_ui FROM users;"
    ],
    origin: "NULLなら次の値…を左から順に選ぶ関数。",
    usage: "NULLをデフォルト値に置き換えたいときに使う。\n例：表示名がNULLなら本名、さらにNULLなら 'unknown' を表示する。"
  }
];
